import { SELECT_EMPTY_VALUE } from '@/components/ui/select';

const CONTROLS = [
  'input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=file]):not([type=search]):not([role=combobox]):not([aria-autocomplete])',
  'textarea',
  'select',
].join(', ');

const RECHECK_EVENTS = ['input', 'change', 'click', 'focusout'] as const;
const RECHECK_DELAY_MS = 30;
const watched = new WeakSet<Element>();

type ValueControl = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;

export function fieldIsEmpty(field: Element): boolean {
  const explicit = field.querySelectorAll<HTMLInputElement>('[data-field-value]');
  const controls: ValueControl[] = explicit.length ? [...explicit] : [...field.querySelectorAll<ValueControl>(CONTROLS)];
  if (controls.length === 0) return false;
  return controls.every((control) => {
    const value = control.value.trim();
    return !value || value === SELECT_EMPTY_VALUE;
  });
}

function isShown(field: HTMLElement): boolean {
  return field.getClientRects().length > 0;
}

function clearFilled(root: Element) {
  root.querySelectorAll('[data-missing]').forEach((field) => {
    if (!fieldIsEmpty(field)) field.removeAttribute('data-missing');
  });
}

function watch(root: Element) {
  if (watched.has(root)) return;
  watched.add(root);
  const recheck = () => window.setTimeout(() => clearFilled(root), RECHECK_DELAY_MS);
  RECHECK_EVENTS.forEach((type) => root.addEventListener(type, recheck, true));
}

export function markMissingFields(root: Element): HTMLElement | null {
  let first: HTMLElement | null = null;
  root.querySelectorAll<HTMLElement>('[data-required-field]').forEach((field) => {
    if (isShown(field) && fieldIsEmpty(field)) {
      field.setAttribute('data-missing', '');
      first ??= field;
    } else {
      field.removeAttribute('data-missing');
    }
  });
  watch(root);
  return first;
}

export function revealMissingField(field: HTMLElement) {
  field.scrollIntoView({ block: 'center' });
  field.querySelector<HTMLElement>(`${CONTROLS}, [role=combobox], button`)?.focus({ preventScroll: true });
}
